import { html } from 'lit';
import { FontSizes, FontWeights } from '../../types/common/types';

export function createRows(detailsInfo, naValue) {
  return detailsInfo.map(info => {
    const value = typeof info.value === 'string' ? info.value.trim() : info.value;
    let content = value === '' || value == null ? naValue : value;

    if (info.callback) {
      content = html`
        <gz-link
          class="finding-details-link"
          fontSize="${FontSizes.PARAGRAPH_13}"
          fontWeight="${FontWeights.NORMAL}"
          @click="${info.callback}"
        >
          ${content}
        </gz-link>
      `;
    }

    return html`
      <gz-labeled-content label="${info.label}" labelFontSize="${FontSizes.HEADING_6}">
        <gz-tooltip tooltipText="${content}" isEllipsis>
          ${content}
        </gz-tooltip>
      </gz-labeled-content>`;
  });
}
